<template>
    <div class="templete_box">
        <navTab :navlist="navlist" :nav-index="tab"  :templateName="'bankingPayableRedeemList'" @reback="res=>{this.tab = res;}"></navTab>
        <detail @child-num='emitNum' v-if="Number(tab) === 0"></detail>
        <stream @child-num='emitNum' v-if="Number(tab) === 1"></stream>
    </div>
</template>
<script>
    import detail from './components/detail';
    import stream from './components/stream';
    export default {
        data(){
            return{
                navlist:['赎货详情','赎货流水'],
                tab:1,
                saleNum:''
            }
        },
        created(){
            if(sessionStorage.TOSHORTDETAIL){
                this.tab=Number(sessionStorage.TOSHORTDETAIL);
                sessionStorage.removeItem("TOSHORTDETAIL")
            }else{
                this.tab=0;
            }
            // this.emitNum()
        },
        methods:{
            emitNum(data){
                // this.saleNum = data;
                // this.navlist = ['销售赎货'+'('+ data.sales_count+')','提前赎货'+'('+ data.advance_count+')']
            }
        },
        components:{
            detail,
            stream
        }
    }
</script>
<style scoped>

</style>